import axios, { AxiosResponse } from 'axios';
import { FetchTagLoungesType } from '../redux/lounges/slice';
import { Lounge } from '../redux/lounges/types';
import { GET_BASE_URL } from '../constants/apiEndpoints';

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

function shouldRetry(err: any): boolean {
  if (!axios.isAxiosError(err)) return false;
  const status = err.response?.status;
  return status == null || status >= 500 || status === 429;
}

export const getTagLoungesApi = async ({
  sortType,
  LoungeId,
  currentPage,
  tagValue,
  shortByTime,
}: FetchTagLoungesType) => {
  const normalizedTagValue = `${tagValue ?? ''}`.trim();
  if (!normalizedTagValue) {
    return [];
  }

  const responseBody = (response: AxiosResponse) => response.data;

  const user_id = localStorage.getItem('user_id');
  const token = localStorage.getItem('token');
  const page = Number(currentPage) > 0 ? Number(currentPage) : 1;
  const sortByTime = shortByTime === 'true' ? `&sortordefault=ww` : '';
  localStorage.setItem('pagename', normalizedTagValue);
  const apiEndpoint =
    GET_BASE_URL +
    `/api/v1/tag?page=${page}&user_id=${user_id}&tags_name=${encodeURIComponent(
      normalizedTagValue
    )}` +
    sortByTime;

  const getRequest = async (url: string) => {
    try {
      return await axios
        .get<Lounge[]>(url, {
          headers: {
            ...(token ? { Authorization: `bearer ${token}` } : {}),
          },
        })
        .then(responseBody);
    } catch (err) {
      if (!shouldRetry(err)) throw err;
      await sleep(650);
      return await axios
        .get<Lounge[]>(url, {
          headers: {
            ...(token ? { Authorization: `bearer ${token}` } : {}),
          },
        })
        .then(responseBody);
    }
  };

  const { data } = await getRequest(`${apiEndpoint}`);
  return data;
};
